export default "__VITE_ASSET__cfc70d45__"